import { insertPortofolio } from "../../../api/portofolioAPI";
import Swal from "sweetalert2";

export const handleSubmit = async (
  e,
  name,
  imageUrl,
  link,
  status,
  type,
  toggleModal,
  category = ""
) => {
  e.preventDefault();

  if (!name) {
    Swal.fire({ icon: "error", title: "Oops...", text: "Nama portofolio wajib diisi" });
    return;
  }

  try {
    Swal.fire({
      title: "Loading...",
      text: "Please wait while we add the portofolio.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    const statusAsInt = status ? 1 : 0;

    await insertPortofolio({
      name,
      img: imageUrl,
      link,
      status: statusAsInt,
      type,
      category,
    });

    Swal.fire({
      icon: "success",
      title: "Success",
      text: "Portofolio added successfully",
    }).then(() => {
      window.location.reload(); 
    });

    toggleModal();
  } catch (error) {
    console.error("Failed to add portofolio:", error.response ? error.response.data : error);
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "Failed to add portofolio",
    });
  }
};
